import React, { useEffect } from 'react'
import LoginForm from './LoginForm'
import { Link } from 'react-router-dom'
import { Container } from '@material-ui/core'
import { Helmet } from 'react-helmet'


const Login = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    })

    return (
        <>
            <Helmet>
                <title>منم ، هویت دیجیتالی تو - ورود</title>
            </Helmet>

            <main id='login'>

                <Container maxWidth='sm'>
                    <section id='login-form'>
                        <LoginForm />

                        <section id="link-to-register">
                            <span className='text-white'>هنوز ثبت نام نکرده اید؟</span>
                            <Link to='register'>
                                <span>اینجا ثبت نام کنید</span>
                            </Link>
                        </section>
                    </section>
                </Container>

            </main>
        </>
    )
}

export default Login